import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const useUniversityFilter = () => {
    const { t } = useTranslation();
    const { list: majorList, loading: majorLoading } = useSelector((state) => state.major);
    const { locations, loading: universityLoading } = useSelector((state) => state.university);

    return useMemo(
        () => [
            {
                key: "status",
                label: t("common.status") || "Status",
                type: "select",
                options: [
                    { label: t("common.active") || "Active", value: "true" },
                    { label: t("common.inactive") || "Inactive", value: "false" },
                ],
            },
            {
                key: "major_ids",
                label: t("university.majors") || "Majors",
                loading: majorLoading,
                type: "select",
                mode: "multiple",
                options: Array.isArray(majorList) ? majorList.map((m) => ({ label: m.name, value: m.id })) : [],
            },
            {
                key: "location",
                label: t("university.location") || "Location",
                loading: universityLoading,
                type: "select",
                options: Array.isArray(locations) ? locations.map((loc) => ({ label: loc, value: loc })) : [],
            },
        ],
        [t, majorList, locations]
    );
};

export default useUniversityFilter;
